module.exports = __webpack_public_path__ + "img/bg-4.df8f5aba.jpg";